import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_CURRENT_ACCOUNT } from 'src/hooks/accounts/get-current-account.hook';
import { GET_DATEV_NUMBERS } from 'src/hooks/datev-numbers/get-datev-numbers.hook';

import { GET_CURRENT_COMPANY } from './get-current-company.hook';
import { GET_COMPANY_BY_ID } from './get-company-by-id.hook';
import { GET_ALL_PLATFORM_COMPANIES } from './get-all-platform-companies.hook';

const UPDATE_CURRENT_COMPANY = gql`
  mutation updateCurrentCompany($payload: PartialCompanyInput!) {
    updateCurrentCompany(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateCurrentCompany = () => {
  const { t } = useTranslation('common');

  const [updateCurrentCompany] = useMutation(UPDATE_CURRENT_COMPANY, {
    refetchQueries: [
      GET_CURRENT_ACCOUNT,
      GET_CURRENT_COMPANY,
      GET_COMPANY_BY_ID,
      GET_DATEV_NUMBERS,
      GET_ALL_PLATFORM_COMPANIES,
    ],
    onError: (error: any) =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('notifications.error.title'),
        ...(error && { description: error.message || error.errorMessage }),
      }),
  });

  return updateCurrentCompany;
};
